
import {Vue, Prop, Component} from "vue-property-decorator";
import TableColumn from "@/interfaces/TableColumn"

@Component
export default class TableHeaderComponent extends Vue {
    @Prop() columns!: TableColumn[];
}
